/* AMC header behaviors — mobile menu + smooth anchors.
   Ported 5 Jul 2026 from the legacy theme's amc-chrome.js (near-verbatim;
   already clean). Hooks: .js-hamburger, .js-headerMenu, .js-cartCount
   (cart count is updated by markup, not this file). */
(function(){
  function ready(fn){document.readyState!='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var ham=document.querySelector('.js-hamburger'),menu=document.querySelector('.js-headerMenu');
    function close(){if(!ham||!menu)return;var wasOpen=menu.classList.contains('state_open');ham.classList.remove('is-active');menu.classList.remove('state_open');ham.setAttribute('aria-expanded','false');document.body.style.overflow='';if(wasOpen)ham.focus();}
    if(ham&&menu){
      ham.addEventListener('click',function(){
        var open=ham.classList.toggle('is-active');
        menu.classList.toggle('state_open',open);
        ham.setAttribute('aria-expanded',open?'true':'false');
        document.body.style.overflow=open?'hidden':'';
        if(open){var f=menu.querySelector('a');if(f)f.focus();}else{ham.focus();}
      });
      menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){ if(window.innerWidth<=992) close(); });});
      window.addEventListener('keydown',function(e){if(e.key=='Escape')close();});
    }
    document.querySelectorAll('a.js-scrollAnchor, a.-js-scrollAnchor').forEach(function(a){
      a.addEventListener('click',function(e){var id=(a.getAttribute('href')||'').split('#')[1];var t=id&&document.getElementById(id);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});close();}});
    });
  });
})();

/* AMC ruling 26 AUG 2026 — waitlist-signup analytics comment revision
   (documentation only; executable JS unchanged).

   Send amc_waitlist_signup exactly once, only for the capture instance whose
   Shopify customer form succeeded. Read signup_type from that instance's
   contact[tags] value. Because the Google tag may initialize after
   DOMContentLoaded, retry briefly with a bounded timer. After dispatch, remove
   only customer_posted from the current URL to prevent refresh duplication.
   No persistent cross-navigation deduplication is used. GA4 key-event
   designation is a separate administrator decision, made only after
   production receipt is verified. */
(function(){
  function ready(fn){document.readyState!='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var h=(location.hash||'').slice(1);
    var posted=new URLSearchParams(location.search).get('customer_posted')==='true';
    if(!posted||!h)return;
    var mineEl=null,tagValue='';
    document.querySelectorAll('[data-cs-capture]').forEach(function(el){
      var ok=el.querySelector('.amc-cs__ok'),fields=el.querySelector('.amc-cs__fields');
      if(!ok||!fields)return;
      var mine=h===el.getAttribute('data-cs-id');
      ok.hidden=!mine; fields.hidden=mine;
      if(mine){
        mineEl=el;
        var tagInput=el.querySelector('input[name="contact[tags]"]');
        tagValue=tagInput?tagInput.value:'';
      }
    });
    if(!mineEl)return;
    var sent=false,pollId=null,stopId=null;
    function stop(){if(pollId){clearInterval(pollId);pollId=null;}if(stopId){clearTimeout(stopId);stopId=null;}}
    function attempt(){
      if(sent)return;
      if(typeof window.gtag!=='function')return;
      sent=true;
      stop();
      window.gtag('event','amc_waitlist_signup',{signup_type:tagValue});
      var params=new URLSearchParams(location.search);
      params.delete('customer_posted');
      var qs=params.toString();
      history.replaceState(null,'',location.pathname+(qs?'?'+qs:'')+location.hash);
    }
    attempt();
    if(!sent){
      pollId=setInterval(attempt,100);
      stopId=setTimeout(stop,3000);
    }
  });
})();
